import { Bell, ShieldCheck, type LucideIcon } from 'lucide-react'

export type ServiceTab = {
  // Path segment under /services/$slug — must match a route in router.tsx.
  segment: 'health' | 'simulator' | 'workflows' | 'transactions' | 'dashboard' | 'api-spec' | 'docs'
  label: string
}

export type ServiceDescriptor = {
  slug: string
  name: string
  description: string
  icon: LucideIcon
  tabs: ServiceTab[]
}

// Registry of every backend service the portal knows about. Adding a service
// here is the only change needed to make it appear in the catalog.
//
// Icons come from lucide-react — never emoji. Pick the name from
// https://lucide.dev/icons/ and import it at the top.
export const services: ServiceDescriptor[] = [
  {
    slug: 'notification_center',
    name: 'Notification Center',
    description: 'Trigger-driven notifications (in-app/email/push) for LMS, LOS and Gov Pocket.',
    icon: Bell,
    tabs: [
      { segment: 'health', label: 'Health Check' },
      { segment: 'simulator', label: 'Simulator' },
      { segment: 'workflows', label: 'Workflows' },
      { segment: 'transactions', label: 'Transactions' },
      { segment: 'dashboard', label: 'Dashboard' },
      { segment: 'api-spec', label: 'API Spec' },
      { segment: 'docs', label: 'Docs' },
    ],
  },
  {
    slug: 'pii_access_control',
    name: 'PII Access Control',
    description: 'Personally Identifiable Information lookup with full audit trail.',
    icon: ShieldCheck,
    tabs: [
      { segment: 'health', label: 'Health Check' },
      { segment: 'api-spec', label: 'API Spec' },
      { segment: 'dashboard', label: 'Dashboard' },
      { segment: 'transactions', label: 'Transactions' },
    ],
  },
]

export const findService = (slug: string): ServiceDescriptor | undefined =>
  services.find((s) => s.slug === slug)
